<template>
  <div class="card floating">
    <div class="card-title">
      <h2>{{ $t('prompts.newInbox') }}</h2>
    </div>

    <div class="card-content">
      <p>{{ $t('prompts.newInboxMessage') }}</p>
      <input class="input input--block" type="text" @keyup.enter="submit" v-model.trim="name" v-focus>

      <p>{{ $t('prompts.newInboxDescription') }}</p>
      <textarea class="input input--block" type="text" @keyup.enter="submit" v-model.trim="description" rows="5"></textarea>
    </div>

    <div class="card-action">
      <button
        class="button button--flat button--grey" id ="buttonCancelNewInbox"
        @click="$store.commit('closeHovers')"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')"
      >{{ $t('buttons.cancel') }}</button>
      <button
        class="button button--flat" id ="buttonNewInbox"
        :aria-label="$t('buttons.create')"
        :title="$t('buttons.create')"
        @click="submit"
      >{{ $t('buttons.create') }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { files as api } from '@/api';

export default {
  name: 'new-inbox',
  data: function() {
    return {
      name: '',
      description: ''
    };
  },
  computed: {
    ...mapGetters([ 'isFiles', 'isListing' ]),
    ...mapState(['req'])
  },
  methods: {
    submit: async function(event) {
      event.preventDefault();
      if (this.new === '') return;

      document.getElementById('buttonNewInbox').disabled = true;
      document.getElementById('buttonCancelNewInbox').disabled = true;

      try {
        await api.createInbox(this.name, this.description);
      } catch (e) {
        this.$showError(e);
      }

      this.$store.commit('closeHovers');
    }
  }
};
</script>

